import {
    ChangeDetectionStrategy,
    Component,
    Injector,
    Input,
    OnChanges,
    SimpleChange,
    SimpleChanges,
    ViewEncapsulation,
    output,
} from '@angular/core';
import { FiInfiniteScrollDataSource, TSortOrder } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { ObjectTypes } from '@fi-shared/types';
import { isEqual } from '@fi-shared/utils';
import { IChecklist2ReportAttentionRequired } from '../../../shared/fi-checklist2-report';

@Component({
    selector: 'fi-deviation-checkpoints-table',
    templateUrl: './deviation-checkpoints-table.component.html',
    styleUrls: ['./deviation-checkpoints-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-deviation-checkpoints-table', ['class.table-item-selection-prevented']: 'isTableItemSelectionPrevented' },
    standalone: false,
})
export class FiDeviationCheckpointsTableComponent
    extends FiInfiniteScrollDataSource<IChecklist2ReportAttentionRequired>
    implements OnChanges
{
    @Input() attentionRequired: IChecklist2ReportAttentionRequired[];
    @Input() isTableItemSelectionPrevented: boolean;
    public openAttentionRequired = output<IChecklist2ReportAttentionRequired>();
    
    public readonly defaultSortColumnName: string = 'NewAnswers';
    public readonly defaultSortDirection: boolean = true;
    public readonly itemsListType = FiItemsListType.ChecklistReportDeviationsTable;
    public readonly objectType: ObjectTypes = ObjectTypes.Checklist2;

    protected getRowClassFn = (): string => {
        return this.isTableItemSelectionPrevented ? '' : 'cursor-pointer';
    }

    constructor(injector: Injector) {
        super(injector);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const change: SimpleChange = changes.attentionRequired;
        if (!!change && !isEqual(change.currentValue, change.previousValue)) this.reloadData();
    }

    private readonly deviationStatusColumnName: string = 'NewAnswers';
    protected getSortOrderFn(): TSortOrder<IChecklist2ReportAttentionRequired> {
        if (this.selectedSort.active === this.deviationStatusColumnName) return this.getDeviationStatusSort.bind(this);

        return super.getSortOrderFn();
    }

    // Sort by Total answers and OldAnswers
    private getDeviationStatusSort(item: IChecklist2ReportAttentionRequired): number {
        const total = this.getNewAnswerIds(item) + this.getOldAnswerIds(item);
        // Convert to number TTTOOO format: where T is total and O is OldAnswers
        return total * 1000 + this.getOldAnswerIds(item);
    }

    public getListData(): Promise<IChecklist2ReportAttentionRequired[]> {
        return Promise.resolve(this.attentionRequired);
    }

    protected getNewAnswerIds(item: IChecklist2ReportAttentionRequired): number {
        return item.NewAnswers.length;
    }

    protected getOldAnswerIds(item: IChecklist2ReportAttentionRequired): number {
        return item.OldAnswers.length;
    }

    protected onAttentionRequiredRowClick(attentionRequired: IChecklist2ReportAttentionRequired): void {
        this.openAttentionRequired.emit(attentionRequired);
    }
}
